exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.check-err-title {\n  color: #f00;\n  font-weight: 500;\n}\n.check-err-line {\n  line-height: 30px;\n}\n", ""]);

// exports
